import { render, staticRenderFns } from "./RecoverPassModal.vue?vue&type=template&id=a2bb1ef0&"
import script from "./RecoverPassModal.vue?vue&type=script&lang=js&"
export * from "./RecoverPassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports